import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSHistory = {
    name: 'VS History',
    imageUrl: '../../images/VSHistory.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSSnapshot = {
    name: 'VS History',
    imageUrl: '../../images/VSSnapshot.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSSnapbar = {
    name: 'VS History',
    imageUrl: '../../images/VSSnapbar.png',
    imageSize: "80%",
    bradius: 20,
  };

const UIVSSummary = {
    name: 'VS History',
    imageUrl: '../../images/VSSummary.png',
    imageSize: "99%",
    bradius: 20,
  };


export const VSHistory = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Vulnerability Scan History</b><br/><br/>
      Any existing vulnerability scans that have either been completed or canceled are shown in the vulnerability 
      scan history table. <br/><br/>
      Select a Vulnerability Scan type from the options shown at the top (All Scans, Internal Authenticated, 
      Internal Unauthenticated, External, Web App) to see results filtered by category.<br/><br/>
      The information displayed includes scan names, the targets scanned, individuals who issued the scan, 
      start and end dates, no. of vulnerabilities found broken down by severity, mitigation options and Actions to take. <br/><br/>
      By default, the scan history display will show 10 results. However, depending on the volume of scans you have 
      performed previously, there are additional features allowing you to apply a filter to any particular scan should 
      you wish to locate it quickly. For example: <br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Select scan type - Choose from Internal Authenticated, Internal Unauthenticated, External, Web App scans </li>      
      <li>Search box - Type the name of the specific scan you are looking for in the search box to find it quickly </li>
      </ul><br/>
      <b>Take action</b><br/><br/>
      Within the table, you can go to the Action column to create an action - either delete a scan or begin building 
      a mitigation plan.<br/><br/>Please note that the delete scan icon is not shown when there is a mitigation plan 
      in place for this vulnerability scan. In addition, the create a mitigation plan option is not shown when there 
      are zero vulnerabilities or when all targets have already been assigned to a pre-existing plan. <br/><br/>
      Should a new mitigation plan be required, select the three dots under Action and a mitigation plan builder will 
      appear. For help on how to create a mitigation plan, click <b>Mitigation&gt;Create a Mitigation</b> from the top 
      navigation bar on the page. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSHistory.imageUrl}
        alt={'Image of ' + UIVSHistory.name}
        style={{
          width: UIVSHistory.imageSize,
          borderRadius: UIVSHistory.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSSnapshot = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Individual Scan Result Snapshot</b><br/><br/>
      Click on any scan name to expand and view a quick snapshot of the scan result including:  
      <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>The Risk Grade</li>      
      <li>Number of vulnerabilities found, broken down by severity</li>
      <li>A list of the top 5 vulnerabilities (CVEs) found with Risk Levels and count.</li>
      </ul><br/><br/>
      You can also drill-down into vulnerabilities found on each Device/Target. Click on the bars 
      shown in the Vulnerability Breakdown chart (shown below) to view the Host Vulnerability Summary or 
      device-specific scan results.<br/><br/>
      <img
        src={UIVSSnapbar.imageUrl}
        alt={'Image of ' + UIVSSnapbar.name}
        style={{
          width: UIVSSnapbar.imageSize,
          borderRadius: UIVSSnapbar.bradius,
        }}
      />
      </div>
      <div style={helpimg}>
      <img
        src={UIVSSnapshot.imageUrl}
        alt={'Image of ' + UIVSSnapshot.name}
        style={{
          width: UIVSSnapshot.imageSize,
          borderRadius: UIVSSnapshot.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSSummary = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Host Vulnerability Summary</b><br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Summary of how many vulnerabilities were found, their severity rating, and the overall grade for that target </li>      
      <li>Security software that is installed </li>
      <li>End of life information identified for that operating system </li>
      <li>Root cause list accompanied by the corresponding number of vulnerabilities. This is a very important aspect 
      of understanding and mitigating vulnerabilities. Rather than focusing on a detailed list of CVEs that need to 
      be mitigated, the CVEs are summarized and grouped into a root cause list. Root causes present the causes of 
      vulnerabilities at their most basic level. Each can be selected to drill down for more detail. Root causes 
      may include: </li>
      </ul>
      <ul style={{marginLeft: '6em'}}>
      <li>Names of products or software applications that are installed on a host </li>  
      <li>The file path to files that have vulnerable versions (such as outdated drivers) </li>  
      <li>Specific patch identifiers from vendors such as Microsoft, Adobe, and Google </li>  
      </ul><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Beneath the summary section, a full detail list is provided for each of the 
      vulnerabilities found for that particular target, which also shows the risk level and exploitability. </li>  
      </ul><br/>
      </div>
      <div style={helpimg}>
      <img
        src={UIVSSummary.imageUrl}
        alt={'Image of ' + UIVSSummary.name}
        style={{
          width: UIVSSummary.imageSize,
          borderRadius: UIVSSummary.bradius,
        }}
      />
      </div>
    </div>
  );
};
